(() => {
  'use-strict';

  const doc = document.documentElement;
  let viewportWidth,
    documentTop,
    headerHeightTop,
    cards,
    cardOffset,
    bobbinOffset,
    bobbinPBS,
    bobbinPBE,
    firstCardOffset,
    lastCardOffset,
    bodyStyles,
    breakpointWhereCardFades;

  function setBobbin(bobbin) {
    let highlightCardHeight,
      fullBgCardHeight,
      firstCardHeight,
      newSectionBobbinContainerHeight,
      leftSectionHeight,
      leftSectionPBS,
      leftSectionPBE,
      totalLeftSectionHeight;

    // Get all cards in the bobbin
    cards = bobbin.querySelectorAll('.Card-container');

    // Get padding for .cards
    bobbinPBS = parseInt(
      window
        .getComputedStyle(bobbin, null)
        .getPropertyValue('padding-block-start'),
    );
    bobbinPBE = parseInt(
      window
        .getComputedStyle(bobbin, null)
        .getPropertyValue('padding-block-end'),
    );

    // Get bobbin container to set its height according to the screen height
    const sectionBobbinContainer = bobbin.closest('.Section.-bobbin');
    const leftSection = sectionBobbinContainer.querySelector('.Section-left');

    viewportWidth = window.innerWidth || document.documentElement.clientWidth;

    if (viewportWidth >= window.breakpointsDefinition['desktop']) {
      // Get the first card height
      firstCardHeight = bobbin.querySelector(
        '.Card-container:first-child',
      ).offsetHeight;

      // Get header height
      bodyStyles = window.getComputedStyle(document.body);
      headerHeightTop = parseInt(
        bodyStyles.getPropertyValue('--site-header-height--top'),
      );

      // Calculate the better height for the bobbin
      newSectionBobbinContainerHeight =
        headerHeightTop + bobbinPBS + firstCardHeight + bobbinPBE + 2;

      // Get left section height
      leftSectionHeight = leftSection.offsetHeight;
      leftSectionPBS = parseInt(
        window
          .getComputedStyle(leftSection, null)
          .getPropertyValue('padding-block-start'),
      );
      leftSectionPBE = parseInt(
        window
          .getComputedStyle(leftSection, null)
          .getPropertyValue('padding-block-end'),
      );
      totalLeftSectionHeight =
        leftSectionPBS + leftSectionHeight + leftSectionPBE;

      // If the left is bigger than the "ideal" height for the right, then the parent section's height is the left's height
      if (totalLeftSectionHeight > newSectionBobbinContainerHeight) {
        newSectionBobbinContainerHeight = totalLeftSectionHeight;
      }

      // Set the new height for the bobbin container
      sectionBobbinContainer.style.setProperty(
        'height',
        newSectionBobbinContainerHeight + 'px',
      );
    } else {
      // On mobile only
      sectionBobbinContainer.style.setProperty('height', 'auto');
    }

    setBobbinOffset(bobbin);
  }

  function setCardsOpacity() {
    // Get header height
    bodyStyles = window.getComputedStyle(document.body);
    headerHeightTop = parseInt(
      bodyStyles.getPropertyValue('--site-header-height'),
    );

    if (
      viewportWidth >= window.breakpointsDefinition['tablet'] &&
      viewportWidth < window.breakpointsDefinition['desktop']
    ) {
      breakpointWhereCardFades = bobbinOffset.top;
    } else if (viewportWidth >= window.breakpointsDefinition['desktop']) {
      breakpointWhereCardFades = bobbinOffset.top + headerHeightTop;
    }

    if (viewportWidth >= window.breakpointsDefinition['tablet']) {
      cards.forEach((card) => {
        cardOffset = card.getBoundingClientRect();

        if (Math.round(cardOffset.top) < Math.round(breakpointWhereCardFades)) {
          if (!card.classList.contains('-faded')) {
            card.classList.add('-faded');
          }
        } else {
          if (card.classList.contains('-faded')) {
            card.classList.remove('-faded');
          }
        }
      });
    }
  }

  function setBobbinOffset(bobbin) {
    bobbinOffset = bobbin.getBoundingClientRect();
  }

  function init(elements) {
    elements.forEach((bobbin) => {
      setBobbin(bobbin);

      window.addEventListener(
        'resize',
        () => {
          setBobbin(bobbin);
        },
        false,
      );

      window.addEventListener(
        'scroll',
        () => {
          setBobbinOffset(bobbin);
        },
        false,
      );

      bobbin.addEventListener(
        'scroll',
        () => {
          setCardsOpacity();
        },
        false,
      );

      bobbin.addEventListener(
        'scrollend',
        () => {
          // Get document top to adjust the scroll
          documentTop =
            (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

          // When at the start or end of the bobbin, scroll does not work if the cursor is not moved.
          // Forces scroll if the bobbin was set with a data-start or data-end during a previous scrollend event
          if (bobbin.dataset.start === 'true' && documentTop > 0) {
            scroll(0, documentTop - 1);
          }
          if (bobbin.dataset.end === 'true') {
            scroll(0, documentTop + 1);
            bobbin.dataset.end = 'false';
          }

          // Get offsets for first and last card
          firstCardOffset = cards[0].getBoundingClientRect();
          lastCardOffset = cards[cards.length - 1].getBoundingClientRect();

          // Set data attribute if the bobbin is at the start or at the end
          firstCardOffset.top > bobbinOffset.top
            ? (bobbin.dataset.start = 'true')
            : (bobbin.dataset.start = 'false');
          lastCardOffset.bottom < bobbinOffset.bottom
            ? (bobbin.dataset.end = 'true')
            : (bobbin.dataset.end = 'false');
        },
        false,
      );
    });
  }

  Drupal.behaviors.bobbin = {
    attach: () => {
      const elements = document.querySelectorAll('.js-bobbin');
      if (elements.length !== 0) {
        init(elements);
      }
    },
  };
  // eslint-disable-next-line no-undef
})();
